/**
 * base64url (RFC 4648 §5) e os primitivos de WebCrypto em cima dele.
 *
 * Mora aqui porque todo o resto do cliente OIDC fala nesse alfabeto: PKCE
 * (`code_verifier`/`code_challenge`), `state`, `nonce` e as tres partes de um
 * JWT. base64 comum quebra em qualquer um deles — `+`, `/` e `=` mudam de
 * significado dentro de uma query string.
 */

const PADDING = 4;

export function encodeBase64Url(bytes: Uint8Array): string {
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function decodeBase64Url(value: string): Uint8Array {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(
    base64.length + ((PADDING - (base64.length % PADDING)) % PADDING),
    '=',
  );
  const binary = atob(padded);
  return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}

/** O texto que estava embutido num segmento base64url — cabecalho e payload de JWT. */
export function decodeBase64UrlText(value: string): string {
  return new TextDecoder().decode(decodeBase64Url(value));
}

/**
 * Aleatorio criptografico em base64url.
 *
 * 32 bytes viram 43 caracteres, o minimo que o RFC 7636 aceita para o
 * `code_verifier`. `Math.random()` nao serve aqui em nenhum dos tres usos: os
 * tres sao segredo de uma tentativa de login.
 */
export function randomBase64Url(bytes: number = 32): string {
  const buffer = new Uint8Array(bytes);
  crypto.getRandomValues(buffer);
  return encodeBase64Url(buffer);
}

export async function sha256(value: string): Promise<Uint8Array> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  return new Uint8Array(digest);
}
